export const validateGroupName = (name: string) => {
  switch (name) {
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'

    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'
    case 'categoriasIds':
      return 'categoriaCompacta'
    case 'categoriasSelectIds':
      return 'categoriaCompacta'
    case 'categoriaIds':
      return 'categoria'
    case 'categoriaSelectIds':
      return 'categoria'
    case 'gerenteCategoriaIds':
      return 'gerenteCategoria'
    case 'gerenteCategoriaSelectIds':
      return 'gerenteCategoria'

    case 'gerenteProdutoIds':
      return 'gerenteProduto'
    case 'gerenteProdutoSelectIds':
      return 'gerenteProduto'

    case 'mundoIds':
      return 'mundo'
    case 'mundoSelectIds':
      return 'mundo'
    case 'productsIds':
      return 'produto'
    case 'productsSelectIds':
      return 'produto'
    default:
      return null
  }
}
